module.exports = __webpack_public_path__ + "img/media_19.260f26a5.jpg";